import { useCallback, useState } from 'react';

import { accountApi } from '../api';
import { trackEventMixpanel } from '../../utils';

export interface InviteCodeResult {
  referralCode: string;
  error?: string;
}

export const useReferralLink = () => {
  const [isGenerating, setIsGenerating] = useState(false);

  const generateReferralLink = useCallback(
    async (userId: string): Promise<InviteCodeResult> => {
      setIsGenerating(true);

      try {
        const { referralCode } = (await accountApi.generateReferralCode(userId)).data;

        trackEventMixpanel('invite_link_generated', {
          channel: 'user_invite',
          referralCode,
        });

        return { referralCode };
      } catch (error) {
        return {
          referralCode: '',
          error: error instanceof Error ? error.message : "Couldn't generate an invite link",
        };
      } finally {
        setIsGenerating(false);
      }
    },
    []
  );

  return {
    generateInviteLink: generateReferralLink,
    isGenerating,
  };
};

export default useReferralLink;
